import { Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { type HttpDataResponse } from '@common/types/http-response.type';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class FileManagerHttpService extends BaseHttpService {
    public loadFile(fileRequest: { file: File; folder: string }): Observable<any> {
        const formData = new FormData();

        formData.append('content[]', fileRequest.file, fileRequest.file.name);
        formData.append('pathToStore', fileRequest.folder);

        return this.http
            .post<HttpDataResponse<any>>(this.formatFileManagerServiceApiUrl('file'), formData)
            .pipe(map((res: HttpDataResponse<any>) => res));
    }

    public resizeFile(url: string, path: string): Observable<any> {
        return this.http
            .post(this.formatApiUrl('files/resize'), { url: encodeURI(url), path })
            .pipe(map((res: HttpDataResponse<any>) => res));
    }
}
